<template>
  <div class="wrraper custom_card" style="">
    <!-- Start Breadcrumb -->
    <Breadcrumb
      :items="items"
      :canAddNew="!canAdd"
      search_route="/about/meta"
      search_title=" Meta"
      icon="fa-code"
    />

    <!-- End Breadcrumb -->
    <MainLoader v-if="loading && !pageData"></MainLoader>
    <div v-if="pageData">
      <div class="portfolio_page">
        <div class="about_us_section">
          <div class="container-xl">
            <div class="row">
              <!-- <router-link class="meta_button" :to="`/about/meta`"> 
                        <v-icon class="edit" small>
                            fal fa-code
                        </v-icon>
                    </router-link> -->
              <div class="about-img col-lg-6 col-md-12">
                <img :src="pageData.intro.image" />
              </div>
              <div class="about-text col-lg-6 col-md-12">
                <h6>عنا</h6>
                <!-- <h6>{{$t('Subtitle.aboutUsSection')}}</h6> -->
                <h2>{{ pageData.intro.title }}</h2>
                <p>
                  {{ pageData.intro.details }}
                </p>
                <!-- <span class="img">5+</span> -->
                <div>
                  <img
                    :src="pageData.intro.features[0].icon"
                    align="center"
                    alt="...."
                    width="120"
                    height="110"
                  />
                  <span class="after_img">
                    <!-- {{$t("SectionsDescription.numberOfOurYears")}} -->
                    {{ pageData.intro.features[0].title }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Start Our Success Section -->
        <div v-for="section in pageData.sections" :key="section.id">
          <div class="success_section" v-if="section.key == 'our_success'">
            <div class="container-xl">
              <h6>{{ $t("ourSuccess") }}</h6>
              <h2>
                {{ section.title }}
                <!-- <span>{{successSection.Companyname}}</span> -->
              </h2>
              <div class="content_box">
                <img :src="section.image" />
                <div class="our_numbers">
                  <div
                    class="number_card"
                    v-for="number in section.features"
                    :key="number.title"
                  >
                    <h2>{{ number.title }}</h2>
                    <p>{{ number.description }}</p>
                  </div>
                </div>
                <p>{{ section.decsription }}</p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tw-grid tw-grid-cols-1 tw-gap-3 sm:tw-grid-cols-2 lg:tw-grid-cols-3"
        >
          <template v-for="section in pageData.sections">
            <template v-if="section.key != 'our_success'">
              <div
                class="tw-p-7 xl:tw-p-10 tw-rounded-xl tw-bg-[#E50E9C08]"
                :key="section.id"
              >
                <div
                  class="icon tw-w-12 tw-h-12 tw-text-xl tw-flex tw-justify-center tw-items-center tw-rounded-full tw-text-white tw-font-bold tw-mb-5"
                >
                  <img
                    :alt="section.title"
                    :src="section.image"
                    align="center"
                    width="48"
                    height="48"
                    class="tw-rounded-full"
                    loading="lazy"
                    sizes="48"
                  />
                </div>
                <div class="content">
                  <h3 class="tw-text-text tw-font-semibold tw-my-2 tw-text-xl">
                    {{ section.title }}
                  </h3>
                  <p class="tw-text-text-light tw-max-w-[300px]">
                    {{ section.description }}
                  </p>
                </div>
              </div>
            </template>
          </template>
        </div>
        <!-- End Our Success Section -->
        <!-- Start Main Header  -->

        <!-- <MainPortfolioHeaderSection :Project="pageData.sections[1]" /> -->
        <!-- End Main Header  -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["id"],
  components: {
    MainPortfolioHeaderSection: () =>
      import("@/components/Project/MainPortfolioHeaderSection.vue"),
    ScreensSection: () => import("@/components/Project/ScreensSection.vue"),
    AppImagesCard: () => import("@/components/Project/AppImageCard.vue"),
    WhyAppSection: () => import("@/components/Project/WhyAppSection.vue"),
    featuresCard: () => import("@/components/Project/featuresCard.vue"),
  },
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.about.title"),
          disabled: false,
          href: "/about",
        },
        {
          text: this.$t("breadcrumb.about.show"),
          disabled: true,
          href: "",
        },
      ],

      loading: false,
      pageData: null,

      // ========== Table
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
  },

  methods: {
    getData() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: `about_us`,
      })
        .then((res) => {
          this.pageData = res.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.loading = false;
          this.$router.push({ path: "/about/update" });
        });
    },
  },

  // ======= hooks
  mounted() {
    this.canAdd = this.$permission.allowed("about/meta");
    this.getData();
  },
};
</script>

<style lang="scss">
// START STYLING MAIN SECTIONS
.portfolio_page {
  position: relative;
  .meta_button {
    position: absolute;
    left: 10px;
    top: 10px;
    border: 1.5px solid #fff;
    background: #fff;
    text-align: center;
    padding: 5px 10px;
    z-index: 2;
    border-radius: 6px;
    font-size: 16px;
  }
  .main_header {
    @include flexSpaceBetweenAlignment;
    min-height: 400px;
    h6 {
      font-size: 20px;
    }
    h2 {
      @include homeSecondTitle;
      font-weight: 900;
      font-size: 50px;
      span {
        @include homeSecondTitle;
        color: var(--mainColor-2);
        font-size: 50px;
      }
    }
    p {
      font-size: 17px;
      color: black;
      font-style: italic;
    }
  }
  .text_section {
    @include verticalFlexStartAlignment;
    padding-inline-end: 10px;
    h3 {
      // font-family: $medium_font;
      font-size: 28px;
      letter-spacing: 1.5px;
      color: #fff;
      font-weight: 600;
    }
    p {
      color: var(--white_clr);
      font-size: 16px;
      // font-family: $regular_font;
      line-height: 32px;
    }
  }
}
.image_inside {
  z-index: 5;
  width: 400px;
  position: absolute;
}
.about_us_section {
  margin: 50px auto 0;
  .about-img {
    height: auto;
    img {
      width: 100%;
      max-width: 650px;
    }
  }
  .about-text {
    @include verticalFlexStartAlignment;
    position: relative;
    h2 {
      @include homeSecondTitle;
    }
    h6 {
      @include homeFirstTitle;
    }
    p {
      // color: black;
      margin-block-end: 20px;
      line-height: 30px;
      // font-family: $regular_font;

      font-size: 18px;
      max-width: 750px;
    }
    span.after_img {
      // font-family: $regular_font;
      font-size: 18px;
      display: inline-block;
      color: #7784c4;
      margin-inline-start: 10px;
    }

    .image_in_background {
      display: none;
    }
  }
}
.success_section {
  h6 {
    @include homeFirstTitle;
  }
  h2 {
    @include homeSecondTitle;
    max-width: 720px;
    line-height: 80px;
    // font-size:42px ;
    font-weight: 900;
    margin-block-end: 50px;
    span {
      color: var(--mainColor-2);
      font-family: inherit;
    }
  }
  .content_box {
    display: block !important;
    height: 650px;
    border-radius: 20px;
    overflow: hidden;
    width: 100%;
    @include verticalFlexStartAlignment;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 75%;
      top: 0;
      left: 0;
      right: 0;
      background: #151d4666;
      z-index: 2;
      border-radius: 20px;
    }
    img {
      width: 100%;
      position: relative;
      left: 0;
      right: 0;
      top: 0;
      height: 75%;
      display: block;
      border-radius: 20px;
      z-index: 1;
    }
    .our_numbers {
      @include flexCenterAlignment;
      column-gap: 25px;
      z-index: 2;
      top: -100px;
      position: relative;
      .number_card {
        width: 190px;
        height: 190px;
        background: var(--mainColor-2);
        border-radius: 15px;
        @include verticalFlexStartAlignment;
        align-items: center;
        row-gap: 10px;
        h2 {
          text-align: center;
          color: #fff;
          // font-family: $;
          font-weight: 800;
          font-size: 48px;
          margin: 0;
        }
        p {
          // font-family: $regular_font;
          font-size: 18px;
          top: 0;
          color: #fff;
        }
      }
    }
    p {
      text-align: center;
      // font-family: $medium_font;
      font-weight: 600;
      font-size: 15px;
      position: relative;
      top: -30px;
      color: black;
      font-style: italic;
    }
  }
}
</style>
